module.exports = __webpack_public_path__ + "img/profess6.a1ef577b.png";